const getSelectedLoginMenu = (state) => state.selectedLoginMenu;
const getListLoginGame = (state) => state.list_login_game;
const getLoginDialog = (state) => state.loginDialog;
export default {
  getSelectedLoginMenu,
  getListLoginGame,
  getLoginDialog
};
